import styled from "styled-components/macro";
import {useParams} from "react-router-dom";
import {useBaseCommunity} from "../../../store/hooks";
import {useCommunityStyle} from "../../../api/communities";
import HeaderData from "../../../components/header_data";
import Header from "../../../components/header";
import TopBar from "../../../components/top_bar";
import CommunityHeader from "../../../components/community_header";
import SortBar from "../../../components/sort_bar";
import Container from "../../../components/container";
import Wrapper from "../../../components/wrapper";
import Main from "../../../components/main";
import Sidebar from "../../../components/sidebar";
import Footer from "../../../components/footer";
import {isPseudoCommunity} from "../../../store/communites";
import {useFlairs} from "../../../api/flairs";
import {useFeedback} from "../../../store/feedback";
import {useModal} from "../../../store";
import EditPostFlair from "../../../components/modals/moderation/edit_post_flair";
import {useEffect, useState} from "react";
import CommunityInfo from "../../../components/community_info";
import {Button} from "@chakra-ui/react";
import useWindowDimensions from "../../../utils/dimensions";
import LegacySortBar from "../../../components/legacy/legacy_sort_bar";
import {themecolors} from "../../../utils/themecolors";
import {Pencil} from "lucide-react";

const Item = styled.div``;
const Edit = styled.div``;


const SetPostFlairs = styled(({className}) => {
    const modal = useModal();
    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    const style = useCommunityStyle(community);
    const {error, feedbackCh} = useFeedback();
    const flairs = useFlairs(feedbackCh, community, "post");

    const [communityFlairs, setCommunityFlairs] = useState([]);
    useEffect(() => {
        if (flairs) {
            setCommunityFlairs(flairs);
        }
    }, [flairs]);

    const handleEdit = (i) => {
       modal.open(EditPostFlair, {communityFlairs, setCommunityFlairs, community, i});
    }

    const {width} = useWindowDimensions();

    return (
        <>
            <HeaderData title={`Community Post Flairs`} community={community} community_style={style}/>
            <Header>
                {(baseCommunity !== "TheDonald" || width <= 780) && <TopBar legacyConversion={baseCommunity === "TheDonald"} />}
                {!isPseudoCommunity(community) &&
                    <>
                        <CommunityHeader community={community}/>
                        {baseCommunity !== "TheDonald" &&
                            <CommunityInfo desktop community={community}/>
                        }
                    </>
                }
                {baseCommunity === "TheDonald" && width > 780 && <LegacySortBar />}
            </Header>
            <SortBar community={community} />
            <Container className={className} forceWidth={"slim"}>
                <Wrapper>
                    <Main>
                        <h3>Set Community Post Flairs</h3>
                        {communityFlairs?.map((flair, i) =>
                            <Item key={i}>
                                <p>
                                    {flair.text}
                                </p>
                                <Edit onClick={() => handleEdit(i)}>
                                    <Pencil size={16} />
                                </Edit>
                            </Item>
                        )}
                        <Button variant='grey' onClick={() => flairs && handleEdit(-1)}>Add</Button>
                    </Main>
                </Wrapper>
                <Sidebar sidebar={style?.sidebar} community={community} />
            </Container>
            <Footer />
        </>
    );
})`
  ${Main} {
    padding: 24px;
  }
  h3 {
    margin: 0 !important;
    padding-bottom: 24px;
    font-size: 18px !important;
    line-height: 18px;
  }
  ${Item} {
    display: flex;
    max-width: 350px;
    margin-bottom: 20px;
    font-size: 15px;
  }
  ${Edit} {
    margin-left: auto;
  }
  ${Edit} svg {
    cursor: pointer;
    width: 20px;
    fill: ${({theme}) => theme.color.name === 'dark' ? '#343536' : '#f0f0f0'};
  }
  ${Edit}:hover svg {
    fill: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : 'rgb(27, 31, 35)'};
  }
`;

export default SetPostFlairs;
